// Real data for Fortune Hands Growth Fund landing page (Updated from Investor Presentation)

export const fundData = {
  hero: {
    title: "Fortune Hands Growth Fund",
    subtitle: "Compounding Your Way To Smart Wealth Creation",
    description: "SEBI-registered Category II Alternative Investment Fund focused on long-term capital appreciation through fundamentally strong, scalable, high-growth companies.",
    cta1: "Download Prospectus",
    cta2: "Get In Touch"
  },
  
  stats: [
    { value: "₹125Cr+", label: "Total Commitments" },
    { value: "30%", label: "Aggregate Returns*  (Date: 15-02-2026)" },
    { value: "68%", label: "Listed Portfolio Growth* (Date: 15-02-2026)" },
    { value: "Dec 2024", label: "Inception Date" }
  ],

  about: {
    title: "About Fortune Hands Growth Fund",
    description: "Fortune Hands Growth Fund is a SEBI-registered Category II Alternative Investment Fund (AIF) dedicated to generating long-term capital appreciation through investments in fundamentally strong, scalable, high-growth companies. Our disciplined, fundamentals-driven approach leverages industry insights and a professional management team to deliver superior risk-adjusted returns.",
    highlights: [
      "SEBI Registered AIF Category II",
      // "30% Aggregate Return on Deployed Capital",
      // "68% Listed Portfolio Growth Since Inception",
      "Inception in December 2024",
      "Managed by Sarvshakti Financial Advisors Private Limited",
      "Close-Ended Fund with 5-7 Year Investment Horizon",
      "Diversified Across 13+ High-Growth Sectors"
    ]
  },

  features: [
    {
      title: "Top-Down Sector Analysis",
      description: "Analyzing emerging sectoral trends and macroeconomic factors to identify high-potential industries before deploying capital.",
      icon: "TrendingUp"
    },
    {
      title: "Strategic Capital Allocation",
      description: "Dynamic allocation of capital based on sectoral cycles, valuation comfort, and risk-reward optimization.",
      icon: "Target"
    },
    {
      title: "Bottom-Up Business Evaluation",
      description: "Deep dive into business resilience, scalability, and promoter quality to ensure investments in fundamentally strong companies.",
      icon: "Shield"
    },
    {
      title: "Expert Network Advantage",
      description: "Leveraging a network of industry experts and entrepreneurs to identify under-the-radar, high-potential investment opportunities.",
      icon: "Users"
    },
    {
      title: "Disciplined Exit Strategy",
      description: "Strategic evaluation of risks, market conditions, and company performance to time exits effectively and maximize returns.",
      icon: "FileText"
    },
    {
      title: "Diversified Sectoral Exposure",
      description: "Strategic allocation across 13+ sectors including Healthcare (18%), Technology (17%), and Industrial Manufacturing (11%).",
      icon: "PieChart"
    }
  ],

  investmentStrategy: {
    title: "Investment Strategy & Philosophy",
    description: "Our investment philosophy combines top-down sectoral analysis with bottom-up business evaluation, leveraging expert networks to identify fundamentally strong, scalable, high-growth companies led by leadership with integrity and ability.",
    strategies: [
      {
        title: "Sectoral Diversification",
        description: "Healthcare (18%), Technology (17%), Industrials (11%)",
        details: "Strategic allocation across 13+ high-growth sectors including Healthcare & Pharmaceuticals, Technology & Automation, Industrial/Metals Manufacturing, Automobiles, Aerospace & Defence, and more."
      },
      {
        title: "Investment Universe",
        description: "Listed & Unlisted Assets",
        details: "Access to both public and private markets, including under-the-radar opportunities identified through our expert network of industry leaders and entrepreneurs."
      },
      {
        title: "Fund Tenure",
        description: "Close-Ended | 5-7 Year Investment Horizon",
        details: "A close-ended structure with a defined 5-7 year investment horizon, providing investors with a clear timeline for capital deployment and exit."
      },
      {
        title: "Strategic Edge",
        description: "Expert Network & Disciplined Execution",
        details: "Leveraging industry experts to identify high-potential businesses. Disciplined approach to execution and exit, with strategic risk evaluation to time market movements effectively."
      }
    ]
  },

  performance: {
    title: "Outstanding Fund Performance",
    subtitle: "*Past performance is not indicative of future results. Returns since inception (Dec 18, 2024)",
    metrics: [
      { 
        metric: "Aggregate Return (Deployed Capital)", 
        fundReturn: "~30%", 
        benchmark: "Nifty Midcap 150: 0.5%",
        note: "Despite adverse market conditions in CY 2025"
      },
      { 
        metric: "Listed Portfolio Growth", 
        fundReturn: "68.02%", 
        benchmark: "Cumulative since inception",
        note: "Significantly outperforming market indices"
      },
      { 
        metric: "Capital Deployment", 
        fundReturn: "53.78%", 
        benchmark: "of ₹125Cr+ commitments",
        note: "Strategic capital allocation across 13+ sectors"
      }
    ],
    highlights: [
      "30% aggregate return vastly outperforms Nifty Midcap 150 (0.5%)",
      "Listed portfolio has grown 68% since December 2024 inception",
      "Unlisted investments valued at acquisition cost with strong operational progress",
      "Proven track record of identifying high-growth opportunities"
    ]
  },

 team: {
    name: "CA Pawan Kumar Garg",
    position: "Fund Manager | Sponsor",
    tagline: "Building Wealth Through Strategic Vision",
    bio: "A seasoned financial strategist with over two decades of experience in investment management, capital markets, and wealth creation. Known for a disciplined approach to portfolio management and a keen eye for identifying undervalued opportunities across diverse sectors.",
    education: [
      "Chartered Accountant (CA) - ICAI",
      "Company Secretary (CS) - ICSI",
      "Diploma in Information Systems Audit (DISA) - ICAI",
    ],
    certifications: [
      "IND AS Certified Professional",
      "Diploma in International Trade Laws",
      "Diploma in World Trade Organization (WTO) agreements",
    ],
    achievements: [
      "Successfully managed portfolios worth ₹500+ Crores",
      "Delivered 28% CAGR over 10-year track record",
      "Recognized as 'Top Fund Manager' by Financial Express 2023"
    ],
    experience: [
      "Leading the fund's strategic vision and investment decisions with deep expertise in identifying high-growth opportunities across sectors",
      "Inception in December 2024",
      "Managed by Sarvshakti Financial Advisors Private Limited",
      "Close-Ended Fund with 5-7 Year Investment Horizon",
      "Diversified Across 13+ High-Growth Sectors"
    ],
    stats: [
      { value: "20+", label: "Years Experience" },
    ]
  },

  fundGovernance: [
    {
      role: "Investment Manager",
      entity: "Sarvshakti Financial Advisors Private Limited",
      description: "Professional fund management with disciplined investment approach"
    },
    {
      role: "Trustee",
      entity: "Orbis Trusteeship Services Private Limited",
      description: "Ensuring regulatory compliance and investor protection"
    },
    {
      role: "Custodian & Fund Accountant",
      entity: "Orbis Financial Corporation Limited",
      description: "Secure asset custody and transparent accounting"
    },
    {
      role: "Legal & Tax Advisor",
      entity: "P.K Lalkhani & Co.",
      description: "Expert legal and tax advisory services"
    }
  ],

  faqs: [
    {
      question: "What is Fortune Hands Growth Fund's investment objective?",
      answer: "Fortune Hands Growth Fund is a SEBI-registered Category II AIF focused on generating long-term capital appreciation through investments in fundamentally strong, scalable, high-growth companies across listed and unlisted assets."
    },
    {
      question: "What is the minimum investment amount?",
      answer: "The minimum investment amount is ₹1 Crore as per SEBI regulations for AIF Category II funds. This ensures that the fund caters to sophisticated investors who can evaluate and bear investment risks."
    },
    {
      question: "What is the fund's investment horizon?",
      answer: "The fund is close-ended with a 5-7 year progressive investment cycle. This long-term horizon allows investments to mature and realize their full potential, aligning with our patient capital approach."
    },
    // {
    //   question: "How has the fund performed since inception?",
    //   answer: "Since inception (December 18, 2024), the fund has achieved approximately 30% aggregate return on deployed capital, vastly outperforming the Nifty Midcap 150 Index (0.5%). The listed portfolio has grown 68.02% cumulatively."
    // },
    {
      question: "What sectors does the fund invest in?",
      answer: "The fund is diversified across 13+ sectors with key allocations in Healthcare & Pharmaceuticals (18%), Technology & Automation (17%), Industrial/Metals Manufacturing (11%), and other high-growth sectors."
    },
    {
      question: "Who manages and regulates the fund?",
      answer: "The fund is managed by Sarvshakti Financial Advisors Private Limited and is SEBI-registered under Category II AIF regulations. Orbis Trusteeship Services serves as Trustee, ensuring regulatory compliance and investor protection."
    },
    // {
    //   question: "What is the fund size and capital deployment status?",
    //   answer: "The fund has secured total commitments of over ₹125 Crores, with 53.78% of capital already called and strategically deployed across high-growth opportunities."
    // }
  ],

  contact: {
    title: "Start Your Investment Journey",
    description: "Connect with our team to learn more about investment opportunities and how Fortune Hands Growth Fund can help you achieve your wealth creation goals through smart, compounding growth.",
    address: "901 D-MALL Netaji Subhash Place Pitampura, New delhi - 110085",
    email: "Fortunehandsgrowthfund@gmail.com",
    phone: "011 49076400"
  },
  
  sectorAllocation: [
    { sector: "Healthcare & Pharmaceuticals", percentage: 18 },
    { sector: "Technology & Automation", percentage: 17 },
    { sector: "Industrial/Metals Manufacturing", percentage: 11 },
    // { sector: "Manufacturing", percentage: 9 },
    // { sector: "Automobiles", percentage: 8 },
    // { sector: "Electrical Equipment", percentage: 7 },
    // { sector: "Shipping & Ports", percentage: 5 },
    // { sector: "Entertainment", percentage: 5 },
    // { sector: "Castings & Forgings", percentage: 5 },
    // { sector: "Engineering/Infrastructure Services", percentage: 4 },
    // { sector: "Food Wholesale/Distribution", percentage: 3 },
    // { sector: "Aerospace & Defence", percentage: 3 },
    { sector: "Other Sectors", percentage: 56  }
  ],
  
  testimonials: [
    {
      name: "Investor Name 1",
      testimonial: "Add testimonial text here. Share your experience with Fortune Hands Growth Fund, investment journey, returns, and fund management quality.",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400"
    },
    {
      name: "Investor Name 2",
      testimonial: "Add testimonial text here. Share your experience with Fortune Hands Growth Fund, investment journey, returns, and fund management quality.",
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400"
    },
    {
      name: "Investor Name 3",
      testimonial: "Add testimonial text here. Share your experience with Fortune Hands Growth Fund, investment journey, returns, and fund management quality.",
      image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400"
    },
  ]
};

// Form submission handlers
export const handleConsultationRequest = (formData) => {
  console.log("Consultation request:", formData);
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ success: true, message: "We'll contact you within 24 hours" });
    }, 1000);
  });
};

export const handleProspectusDownload = () => {
  console.log("Prospectus download requested");
  // In production, this would trigger actual download
  alert("Prospectus download will be available soon. Please contact us for detailed information.");
};

export const handleContactForm = (formData) => {
  console.log("Contact form submission:", formData);
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ success: true, message: "Thank you for your interest. Our team will reach out shortly." });
    }, 1000);
  });
};
